import { Api } from "../../api/Api";
import { BooleanThunk } from "../IStore";
import { CampaignExperimentalSearchRequestDto } from "../models/campaignExperimental/CampaignExperimentalDto";
import { CampaignFormDto } from "../models/campaignExperimental/CampaignFormDto";
import { thunkCreateErrorNotification, thunkCreateSuccessNotification } from "./NotificationActions";

export const GET_ALL_CAMPAIGNS_EXPERIMENTAL = "GET_ALL_CAMPAIGNS_EXPERIMENTAL";

export const thunkGetAllCampaignsExperimental = (searchRequest?: CampaignExperimentalSearchRequestDto): BooleanThunk => async (dispatch) => {
  try {
    const campaigns = await Api.getAllCampaignsExperimental(searchRequest);
    dispatch({
      type: GET_ALL_CAMPAIGNS_EXPERIMENTAL,
      payload: campaigns,
    });
    return true;
  } catch (e) {
    dispatch(thunkCreateErrorNotification("Failed to load campaigns", e));
    return false;
  }
};

export const thunkCreateCampaignExperimental = (campaign: CampaignFormDto): BooleanThunk => async (dispatch) => {
  try {
    await Api.createCampaignExperimental(campaign);
    dispatch(thunkCreateSuccessNotification("Campaign created successfully"));
    return true;
  } catch (e) {
    dispatch(thunkCreateErrorNotification("Failed to create campaign", e));
    return false;
  }
};

export const thunkUpdateCampaignExperimental = (campaignNumber: string, campaign: CampaignFormDto): BooleanThunk => async (dispatch) => {
  try {
    await Api.updateCampaignExperimental(campaignNumber, campaign);
    dispatch(thunkCreateSuccessNotification("Campaign updated successfully"));
    return true;
  } catch (e) {
    dispatch(thunkCreateErrorNotification("Failed to update campaign", e));
    return false;
  }
};

export const thunkDeleteCampaignExperimental = (campaignNumber: string): BooleanThunk => async (dispatch) => {
  try {
    await Api.deleteCampaignExperimental(campaignNumber);
    dispatch(thunkCreateSuccessNotification("Campaign deleted successfully"));
    return true;
  } catch (e) {
    dispatch(thunkCreateErrorNotification("Failed to delete campaign", e));
    return false;
  }
};

export const thunkActivateCampaignExperimental = (campaignNumber: string): BooleanThunk => async (dispatch) => {
  try {
    await Api.activateCampaignExperimental(campaignNumber);
    dispatch(thunkCreateSuccessNotification("Campaign activated successfully"));
    return true;
  } catch (e) {
    dispatch(thunkCreateErrorNotification("Failed to activate campaign", e));
    return false;
  }
};
